import { action, observable } from 'mobx';
import type { RootStore } from './root.store';
import { Automation } from '../models/automation.model';
import {
    IAutomationPreview,
    IAutomationInstance,
    TEMP_AUTOMATION_ID
} from '../types/automation.types';

export class AutomationStore {
    @observable automations: Record<string, Automation> = {};
    @observable automationPreviews: IAutomationPreview[] = null;

    rootStore: RootStore = null;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    @action.bound
    load(automation: IAutomationInstance) {
        this.automations[automation._id] = new Automation(
            automation,
            this.rootStore
        );
    }

    @action.bound
    loadTemp(automation: IAutomationInstance) {
        this.load({ ...automation, _id: TEMP_AUTOMATION_ID });
        return this.automations[TEMP_AUTOMATION_ID];
    }

    @action.bound
    deleteTemp() {
        return delete this.automations[TEMP_AUTOMATION_ID];
    }

    @action.bound
    setAutomationPreviews(automationPreviews: IAutomationPreview[]) {
        this.automationPreviews = automationPreviews;
    }

    @action.bound
    reset() {
        this.automations = {};
        this.automationPreviews = null;
    }

    @action.bound
    getAutomationPreview(automationId: string) {
        return this.automationPreviews?.find(
            automation => automation._id === automationId
        );
    }
}
